module.exports = __webpack_public_path__ + "img/food_groceries.8dc30fea.svg";